import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';

const ModalWorkspace = ({ openModal,closeModal, refresh, dataSpace }) => {
    //Datos Basicos
    const [space, setSpace] = React.useState(null);

    //Loader
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const onOk = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            closeModal();
        }
    }

    const addWorkspace = async () => {
        let dataSend = {
            espacio: space
        }

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}espacio/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                refresh();
                alertModal(true, "Espacio de Trabajo agregado correctamente");
            }
            else {
                throw new Error('Error');
            }
        }).catch(err => {
            alertModal(true, "Ha ocurrido un error en el sistema");
        });
    }

    const updateWorkspace = async () => {
        let dataSend = {
            id:dataSpace.id_espacio,
            espacio: space
        }

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}espacio/update`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                refresh();
                alertModal(true, "Espacio de Trabajo actualizado correctamente");
            }
            else {
                throw new Error('Error');
            }
        }).catch(err => {
            alertModal(true, "Ha ocurrido un error en el sistema");
        });
    }

    React.useEffect(() => {
        if(dataSpace !== null && dataSpace !== undefined) 
        {
            setSpace(dataSpace.espacio);
        }
    }, []);

    return (
        <div>
            <Modal
                open={openModal}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            {
                                dataSpace != null && dataSpace != undefined ?
                                    <h5 className="bold-text">Actualizar Espacio de Trabajo</h5>
                                    :
                                    <h5 className="bold-text">Agregar Espacio de Trabajo</h5>
                            }
                        </div>

                        <Row>
                            <Col md={6}>
                                <TextField
                                    id="txtSpace"
                                    label="Espacio de Trabajo"
                                    value={space}
                                    className='medical-material-form__field'
                                    onChange={(event) => {
                                        setSpace(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>

                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {
                            dataSpace == null ? <Button
                                disabled={false}
                                style={{ marginTop: 10, marginRight: 10 }}
                                variant="contained"
                                className="btn btn-primary btn-sm text-white"
                                onClick={() => {
                                    addWorkspace();
                                }}
                            >
                                Crear
                            </Button>
                                :
                                <Button
                                    disabled={false}
                                    style={{ marginTop: 10, marginRight: 10 }}
                                    variant="contained"
                                    className="btn btn-primary btn-sm text-white"
                                    onClick={() => {
                                        updateWorkspace();
                                    }}
                                >
                                    Actualizar
                                </Button>
                        }
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOk(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalWorkspace;
